import { logger } from '@fiverr-private/obs';

/**
 * The error message thrown when trying to make a specific project API call without attributing it to a project.
 * @type {String}
 */
const NO_PROJECT_ID_ERROR = 'No projectId was given.';

/**
 * The error message thrown when trying to fetch user data without attributing it to a project.
 * @type {String}
 */
const NO_USER_ID_ERROR = 'No userId was given.';

const handleAPIValidationError = (apiName, message) => {
    const error = new Error(`${apiName} - ${message}`);

    logger.error(error);

    return Promise.reject(error);
};

const handleAPIError = (error, message, context = {}) => {
    const { status, data, config = {}, request = {}, response = {} } = error || {};
    const { headers, url, method, params = {} } = config;
    const { data: responseData = {} } = response;
    const { path: fullPath } = request;

    logger.error({
        message,
        status,
        url,
        headers,
        method,
        params,
        data,
        ...context,
        fullPath,
        responseData,
    });

    throw new Error(message);
};

const handleError = (appName, errorMessage, error) => {
    const message = `${appName} - ${errorMessage}`;

    logger.error(message, error);

    throw new Error(message);
};

export { NO_PROJECT_ID_ERROR, NO_USER_ID_ERROR, handleAPIValidationError, handleAPIError, handleError };
